var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckIconGreencom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 11",
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#58A728",
  fillRule: "evenodd",
  d: "M14 2.142c0-.23-.09-.462-.253-.628L12.52.26A.866.866 0 0 0 11.905 0a.866.866 0 0 0-.615.259L5.365 6.325 2.71 3.6a.866.866 0 0 0-.615-.259.866.866 0 0 0-.614.259L.253 4.857a.906.906 0 0 0 0 1.255L4.75 10.71a.866.866 0 0 0 .614.259.866.866 0 0 0 .614-.259l7.768-7.94A.906.906 0 0 0 14 2.142z"
})));
export default SvgCheckIconGreencom;